/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=15e1ae3a&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=15e1ae3a&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-yunxiaobao-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e1ae3a"]])

export default __exports__